import { render } from "./Skeleton.vue?vue&type=template&id=05ab65d0"
import script from "./Skeleton.vue?vue&type=script&lang=js"
export * from "./Skeleton.vue?vue&type=script&lang=js"
script.render = render

export default script